
import React, { useState } from "react";
import GoogleLogin from 'react-google-login'; 
import { useNavigate } from "react-router-dom";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {
    Button,
    TextField,
    Select,
    MenuItem,
    FormControl,
    InputLabel,CircularProgress,
    Typography, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, InputAdornment, Box
} from "@mui/material";
import logo from '../../styles/logo.png';

function RegistrationForm() {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        password: "",
        confirmPassword: "",
        phone: "",
        userType: "",
    });
    const registerApiUrl = process.env.REACT_APP_REGISTER_API;
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [showUserTypeDialog, setShowUserTypeDialog] = useState(false);
    const [responseMessage, setResponseMessage] = useState("");
    const navigate = useNavigate();
    const [openDialog, setOpenDialog] = useState(false);
    const [dialogMessage, setDialogMessage] = useState(''); 
    const [phoneError, setPhoneError] = useState(false);
    const [phoneErrorMessage, setPhoneErrorMessage] = useState('');
    const [passwordError, setPasswordError] = useState(false);
    const [confirmPasswordError, setConfirmPasswordError] = useState(false);
    const [passwordErrorMessage, setPasswordErrorMessage] = useState('');
    const [confirmpasswordErrorMessage, setConfirmPasswordErrorMessage] = useState('');
    const [emailError, setEmailError] = useState(false);
    const [emailErrorMessage, setEmailErrorMessage] = useState("");
    const [onFailureGoogle, setOnFailureGoogle] = useState(false);
    const [handleCloseUserTypeDialog,setHandleCloseUserTypeDialog] = useState(false);
    const [loading, setLoading] = useState(false);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "email") {
            if (!emailRegex.test(value)) {
                setEmailError(true);
                setEmailErrorMessage("Please enter a valid email address.");
            } else {
                setEmailError(false);
                setEmailErrorMessage("");
            }
        }
        if (name === "phone") {
            // Allow only digits and maximum 10 digits
            if (!/^\d*$/.test(value)) {return;}
            if (value.length > 10) {return;}
            setFormData((prevData) => ({  ...prevData, [name]: value, }));
            if (value.length === 10) {
                setPhoneError(false);
                setPhoneErrorMessage('');
            } else {
                setPhoneError(true);
                setPhoneErrorMessage('Phone number must be exactly 10 digits');
            }
            return;
        }
        const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
        if (name === "password") {
            if (!passwordRegex.test(value)) {
                setPasswordError(true);
                setPasswordErrorMessage('Min 8 chars, 1 uppercase, 1 number, 1 special.');
            } else {
                setPasswordError(false);
                setPasswordErrorMessage('');
            }
        }
        if (name === "confirmPassword") {
            if (formData.password !== value) {
                setConfirmPasswordError(true);
                setConfirmPasswordErrorMessage('Passwords do not match');
            } else {
                setConfirmPasswordError(false);
                setConfirmPasswordErrorMessage('');
            }
        }
        setFormData((prevData) => ({ ...prevData, [name]: value }));
    };
    
    const responseGoogle = (response) => {
        if (response && response.profileObj) {
            const { email, name } = response.profileObj;
            setFormData((prevData) => ({ ...prevData, email, name, password: "GoogleUser@123", phone: "0000000000" }));
            setShowUserTypeDialog(true);
        }
    };

    const handleSubmit = (event) => {
        if (event) event.preventDefault();
        if (!formData.name.trim() || formData.name.trim().length <= 1) { setResponseMessage("Name is too short."); return; }
        if (formData.password !== formData.confirmPassword) { setResponseMessage("Passwords do not match"); return; }
         setLoading(true);
        fetch(registerApiUrl, {
            method: "POST",
            body: JSON.stringify(formData),
            headers: { "Content-Type": "application/json" },
        })
        .then((response) => response.json())
        .then((data) => {
    if (data.success) {
        // The backend notifies the admins about the new registration.
        navigate("/mfa-setup", { state: { setupToken: data.setupToken } });
    } else {
        if (data.message === "Email already exists") navigate("/alreadyregistered");
        else { setDialogMessage(data.message); setOpenDialog(true); }
    }
}).catch((error) => console.error("Error:", error))
        .finally(() => {
            setLoading(false);
        });
        
    };

    const togglePasswordVisibility = (field) => {
        if (field === 'password') setShowPassword(!showPassword);
        else setShowConfirmPassword(!showConfirmPassword);
    };

    const handleCloseDialog = () => setOpenDialog(false);

    return (
        <Box sx={{ display: "flex", height: "100vh", overflow: "hidden", backgroundColor: "#0f0c29" }}>
            <style>
                {`
                @keyframes meshGradient {
                    0% { background-position: 0% 50%; }
                    50% { background-position: 100% 50%; }
                    100% { background-position: 0% 50%; }
                }
                @keyframes floatCard {
                    0%, 100% { transform: translateY(0) rotate(0deg); }
                    50% { transform: translateY(-10px) rotate(0.5deg); }
                }
                @keyframes contentEntrance {
                    from { opacity: 0; transform: scale(0.9) translateY(20px); }
                    to { opacity: 1; transform: scale(1) translateY(0); }
                }
                .mesh-bg {
                    background: linear-gradient(-45deg, #240b36, #4f378b, #0f0c29, #2b1055);
                    background-size: 400% 400%;
                    animation: meshGradient 12s ease infinite;
                }
                .glass-panel {
                    background: rgba(255, 255, 255, 0.03);
                    backdrop-filter: blur(15px);
                    border: 1px solid rgba(255, 255, 255, 0.1);
                    border-radius: 30px;
                    padding: 40px;
                    animation: floatCard 6s ease-in-out infinite;
                }
                .entrance-delay {
                    animation: contentEntrance 0.8s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
                }
                `}
            </style>

            {/* Left Section: Branding */}
            <Box className="mesh-bg" sx={{ flex: 1.2, display: { xs: 'none', md: 'flex' }, justifyContent: 'center', alignItems: 'center', position: 'relative' }}>
                <Box className="entrance-delay" sx={{ textAlign: 'center', zIndex: 2, p: 4 }}>
                    <Box component="img" src={logo} sx={{ width: 160, mb: 3, filter: 'drop-shadow(0 0 20px rgba(255,255,255,0.3))' }} />
                    <Typography variant="h1" sx={{ fontFamily: 'Righteous', fontSize: '3.5rem', color: '#fff', mb: 2 }}>
                        Resourcing-Bot
                    </Typography>
                    <Typography variant="h5" sx={{ color: 'rgba(255,255,255,0.7)', fontWeight: 300, letterSpacing: 1.5 }}>
                        Join the Future of Effortless Hiring
                    </Typography>
                </Box>
                <Box sx={{ position: 'absolute', width: '300px', height: '300px', background: 'rgba(79, 55, 139, 0.4)', borderRadius: '50%', filter: 'blur(80px)', top: '10%', left: '10%' }} />
                <Box sx={{ position: 'absolute', width: '400px', height: '400px', background: 'rgba(36, 11, 54, 0.6)', borderRadius: '50%', filter: 'blur(100px)', bottom: '10%', right: '10%' }} />
            </Box>

            {/* Right Section: Form */}
            <Box sx={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', p: 3, background: '#fdfdfd', overflowY: 'auto' }}>
                <Box className="glass-panel entrance-delay" sx={{ width: '100%', maxWidth: 500, background: '#fff !important', boxShadow: '0 20px 60px rgba(0,0,0,0.1) !important', position: 'relative' }}>
                    <IconButton onClick={() => navigate("/login")} sx={{ position: "absolute", top: 15, left: 15, color: "#2b1055" }}>
                        <ArrowBackIcon />
                    </IconButton>
                    
                    <Box sx={{ textAlign: "center", mt: 2, mb: 3 }}>
                        <Typography
                            variant="h4"
                            sx={{
                            fontWeight: 800,
                            fontFamily: "Righteous",
                            color: "#2b1055",
                            mb: 1,
                            }}
                        >
                            Register
                        </Typography>

                        <Typography
                            variant="body2"
                            sx={{
                            color: "text.secondary",
                            }}
                        >
                            Create an account to get started.
                        </Typography>
                        </Box>
                    <form onSubmit={handleSubmit}>
                        <TextField
                            label="Full Name"
                            name="name"
                            fullWidth
                            value={formData.name}
                            onChange={handleChange}
                            required
                            style={{ marginBottom: "20px" }}
                        />
					<TextField
						id="email"
						name="email"
						label="Email"
						type="email"
						value={formData.email}
						onChange={handleChange}
						fullWidth
						required
						style={{ marginBottom: "10px" }}
						error={emailError} 
						helperText={emailError ? emailErrorMessage : ""} 
						FormHelperTextProps={{
						style: { color: "red" },
						}}
					/>
					  <TextField
						label="Password"
						id="password"
						name="password"
						type={showPassword ? 'text' : 'password'}
						value={formData.password}
						onChange={handleChange}
						required
						autoComplete="current-password"
						fullWidth
						error={passwordError}
						helperText={passwordError ? passwordErrorMessage : ''}
						FormHelperTextProps={{
							style: { color: 'red' }, 
						}}
						margin="normal"
						InputProps={{
							endAdornment: (
								<InputAdornment position="end">
									<IconButton onClick={() => togglePasswordVisibility('password')} edge="end">
										{showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
									</IconButton>
								</InputAdornment>
							),
						}}
					/>
					<TextField
						label="Confirm Password"
						id="confirmPassword"
						name="confirmPassword"
						type={showConfirmPassword ? 'text' : 'password'}
						value={formData.confirmPassword}
						onChange={handleChange}
						required
						autoComplete="current-password"
						fullWidth
						error={confirmPasswordError}
						helperText={confirmPasswordError ? confirmpasswordErrorMessage : ''}
						FormHelperTextProps={{
							style: { color: 'red' }, 
						}}

						margin="normal"
						InputProps={{
							endAdornment: (
								<InputAdornment position="end">
									<IconButton onClick={() => togglePasswordVisibility('confirmPassword')} edge="end">
										{showConfirmPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
									</IconButton>
								</InputAdornment>
							),
						}}
					/>
					<TextField
						id="phone"
						name="phone"
						label="Phone Number"
						type="tel"
						value={formData.phone}
						onChange={handleChange}
						fullWidth
						required
                        inputProps={{
                            maxLength: 10,
                            inputMode: "numeric",
                        }}
						error={phoneError}
						helperText={phoneError ? phoneErrorMessage : ''}
						style={{ marginTop: "15px" }}
					/>
					<FormControl fullWidth style={{marginTop:'20px', position: "relative" }}>
						{formData.userType === "" && (
							<InputLabel
							id="userType-label"
							style={{ position: "absolute", top: 0, left: "15px", transform: "translate(0, 50%)", pointerEvents: "none" }}
							>
							User Type
							</InputLabel>
						)}
						<Select
							labelId="userType-label"
							id="userType"
							name="userType"
							value={formData.userType}
							onChange={handleChange}
							style={{ minWidth: "200px", }}
						    MenuProps={{
								PaperProps: {
								  sx: {
									'& .MuiMenuItem-root:hover': {
									  backgroundColor: 'rgba(232, 222, 248, 1)',
									},
								  },
								},
							  }}
						>
							<MenuItem value="">Select</MenuItem>
							<MenuItem value="hiringManager">Hiring Manager</MenuItem>
							<MenuItem value="recruiter">Recruiter</MenuItem>
							<MenuItem value="interviewer">Interviewer</MenuItem>
							<MenuItem value="admin">Admin</MenuItem>
							<MenuItem value="humanResource">Human Resource</MenuItem>
							<MenuItem value="manager">Manager</MenuItem>

							
						</Select>
					</FormControl>
		            <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    width="100%"
                    mt={3}
                    >
				<Button
                variant="contained"
                type="submit"
                color="secondary"
                sx={{
                    width: 240,
                    height: 48,
                    borderRadius: "999px",
                    background: "linear-gradient(135deg, #6750A4, #4F378B)",
                    textTransform: "none",
                    fontWeight: 700,
                    fontSize: "15px",
                    boxShadow: "0 10px 24px rgba(79,55,139,0.25)",
                    "&:hover": {
                    background: "linear-gradient(135deg, #5A3FA0, #3D2B6B)",
                    },
                }}
                >
                {loading ? (
                    <CircularProgress size={24} sx={{ color: "#fff" }} />
                ) : (
                    "Register"
                )}
                </Button>
		
				<Dialog open={openDialog} onClose={handleCloseDialog}>
									<DialogTitle>Error</DialogTitle>
									<DialogContent>
										<Typography>{dialogMessage}</Typography>
									</DialogContent>
									<DialogActions>
										<Button onClick={handleCloseDialog} sx={{ color:'white',textTransform:'none',backgroundColor: "#68548E", borderRadius: '100px',marginLeft: 'auto' ,
                        					'&:hover': {backgroundColor: '#D0BCFF',}}}>
											Close
										</Button>
									</DialogActions>
								</Dialog>
				{/* <div style={{width: "200px",height: "40px",marginLeft: "5px",borderRadius: "20px",overflow: "hidden",border: "1px solid gray",display: "flex",alignItems: "center", justifyContent: "center"  }}>
					<GoogleLogin
					clientId="320668170244-e1pjdbp6jpbutb6vppmr32tvna8t74ak.apps.googleusercontent.com"
					buttonText="SignUp with Google"
					onSuccess={responseGoogle}
					onFailure={onFailureGoogle}
					cookiePolicy={"single_host_origin"}
					style={{ width: "100%",borderRadius: "9999px 9999px 9999px 9999px", border: "2px solid gray" ,padding: "16px 0px 0px 0px",  }}
					/>
				</div> */}
			</Box>
			<br></br>
			</form>
				{/* User type selection dialog */}
				<Dialog open={showUserTypeDialog} onClose={handleCloseUserTypeDialog}   
					sx={{'& .MuiDialog-paper': {width: '700px', height: '300px', },}}>
                    <DialogTitle>Select User Type</DialogTitle>
                    <DialogContent>
                        <FormControl fullWidth>
                            <InputLabel id="userType-label">User Type</InputLabel>
                            <Select
                                name="userType"
                                value={formData.userType}
                                onChange={handleChange}
                                sx={{ borderRadius: '12px', backgroundColor: '#f0f0f7' }}
                            >
                                <MenuItem value="hiringManager">Hiring Manager</MenuItem>
                                <MenuItem value="recruiter">Recruiter</MenuItem>
                                <MenuItem value="interviewer">Interviewer</MenuItem>
                                <MenuItem value="admin">Admin</MenuItem>
                            </Select>
                        </FormControl>

                        <Button 
                            type="submit" 
                            fullWidth 
                            variant="contained" 
                            sx={{ mt: 3, py: 1.5, borderRadius: '12px', background: 'linear-gradient(90deg, #4f378b, #2b1055)', fontWeight: 700, textTransform: 'none', boxShadow: '0 10px 20px rgba(79, 55, 139, 0.3)' }}
                        >
                            Create Account
                        </Button>

                        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
                            <GoogleLogin
                                clientId="320668170244-e1pjdbp6jpbutb6vppmr32tvna8t74ak.apps.googleusercontent.com"
                                buttonText="Sign up with Google"
                                onSuccess={responseGoogle}
                                onFailure={(e) => console.log(e)}
                                style={{ width: '100%', borderRadius: '12px' }}
                            />
                        </Box>
                    </DialogContent>
                    </Dialog>


                    <Typography sx={{ mt: 2, textAlign: 'center', color: 'text.secondary', fontSize: '0.85rem' }}>
                        Already have an account? <Button onClick={() => navigate("/login")} sx={{ color: "#4f378b", fontWeight: 800, textTransform: 'none' }}>Sign In</Button>
                    </Typography>
                </Box>
            </Box>

            <Dialog open={openDialog} onClose={handleCloseDialog} PaperProps={{ sx: { borderRadius: '20px', p: 1 } }}>
                <DialogContent><Typography>{dialogMessage}</Typography></DialogContent>
                <DialogActions><Button onClick={handleCloseDialog}>Close</Button></DialogActions>
            </Dialog>

            <Dialog open={showUserTypeDialog} PaperProps={{ sx: { borderRadius: '20px', p: 2 } }}>
                <DialogTitle>Select Role</DialogTitle>
                <DialogContent>
                    <FormControl fullWidth variant="filled" sx={{ mt: 1 }}>
                        <InputLabel>User Type</InputLabel>
                        <Select name="userType" value={formData.userType} onChange={handleChange}>
                            <MenuItem value="hiringManager">Hiring Manager</MenuItem>
                            <MenuItem value="recruiter">Recruiter</MenuItem>
                            <MenuItem value="interviewer">Interviewer</MenuItem>
                            <MenuItem value="admin">Admin</MenuItem>
                        </Select>
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleSubmit} variant="contained" sx={{ bgcolor: '#4f378b' }}>Submit</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}

export default RegistrationForm;